/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cdpTrackEvent} from '../api'

export const useMutationCdpTrackEvent = createReactQueryMutationHook('cdpTrackEvent', cdpTrackEvent)
